import DashboardCurrentComponentsInterface from "@app/Interface/DashboardCurrentComponentsInterface";
import ErrorResponseInterface from "@app/Interface/ErrorResponseInterface";
import QualityComponentInterface from "@app/Interface/QualityComponentInterface";

export default class DashboardCurrentComponentsModel implements DashboardCurrentComponentsInterface {
    canUserViewComponents: boolean;
    canUserViewQualty: boolean;
    currentComponents: ErrorResponseInterface | QualityComponentInterface[];
    currentQuality: ErrorResponseInterface | QualityComponentInterface[];

    constructor(data?: DashboardCurrentComponentsInterface) {
        this.canUserViewComponents = data?.canUserViewComponents ?? false;
        this.canUserViewQualty = data?.canUserViewQualty ?? false;
        this.currentComponents = data?.currentComponents ?? [];
        this.currentQuality = data?.currentQuality ?? [];
    }
    
}